import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const TaxYearContext = createContext();

export const useTaxYear = () => {
  const context = useContext(TaxYearContext);
  if (!context) {
    throw new Error('useTaxYear must be used within a TaxYearProvider');
  }
  return context;
};

export const TaxYearProvider = ({ children }) => {
  const [selectedYear, setSelectedYear] = useState('all');
  
  const updateSelectedYear = useCallback((year) => {
    setSelectedYear(year);
  }, []);

  const value = useMemo(
    () => ({ selectedYear, setSelectedYear: updateSelectedYear }),
    [selectedYear, updateSelectedYear]
  );

  return (
    <TaxYearContext.Provider value={value}>
      {children}
    </TaxYearContext.Provider>
  );
};

export default TaxYearContext;
